import React, { Component } from 'react'
import { Container, Header, Image } from 'semantic-ui-react'
import Speaker from '../components/speaker';
import SpeakerModal from '../components/speaker-modal';
import speakers from '../data/speakers';

import '../styles/speakerSection.scss'

const speakerDefaultState = {
  title: '',
  name: '',
  institution: '',
  picture: '',
  bio: '',
  session: {
    title: '',
    description: '',

  }

}

class SpeakerSection extends Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      speakers: [],
      modal: {
        show: false,
        speaker: speakerDefaultState,
      },
    }
  }

  componentWillMount(){
    this.setState({
      speakers
    })

  }
  /**
   * Closes the modal no matter where called
   */
  closeModal = () => {
    this.setState({ modal: { show: false, speaker: speakerDefaultState } })
  }

  /**
   * Closes the modal only if clicked outside the modal
   */
  handleClose = e => {
    if (e.target.className === 'modal') {
      this.setState({
        modal: {
          show: false,
          speaker: speakerDefaultState,
        },
      })
    }
  }

  /**
   * Shows the modal with the image
   */
  showModal = speaker => {
    this.setState({
      modal: {
        show: true,
        speaker,
      },
    })
  }

  render() {
    const { speakers } = this.state;

    return <section id="speakers" className="content-deck speaker-section">
      <h1 className="content-deck__headline">Plenaries</h1>
        <Container fluid textAlign='center'>
          <div className="speakers">
            { speakers.map( (speaker, i) => {
              return <Speaker key={`${speaker.name}-${i}`} showModal={this.showModal} speaker={speaker}/>
            })}
          </div>
        </Container>

        <SpeakerModal modal={this.state.modal} handleClose={this.handleClose} closeModal={this.closeModal} />
      </section>
  }
}

export default SpeakerSection



// WEBPACK FOOTER //
// ./src/sections/speakerSection.js